import React from "react";
import { ReactComponent as Logo } from '../images/digiscape-color.svg'
import { Link } from 'react-router-dom';

const NavAndHero = () => {
    return (
        <div className="navbar bg-base-100 shadow-2xl relative z-50">
            <div className="navbar-start">
                <div className="dropdown">
                <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /> </svg>
                </div>
                <ul
                    tabIndex={0}
                    className="menu menu-sm dropdown-content bg-base-100 rounded-box z-50 mt-3 w-52 p-2 shadow">
                    <li><Link to="/services/products">Products</Link></li>
                <li>
                    <details>
                    <summary>Services</summary>
                    <ul className="p-2">
                        <li><Link to="/services/website-branding">Website & Branding</Link></li>
                        <li><Link to="/services/lead-generation">Online Marketing</Link></li>
                        <li><Link to="/services/it-services">IT Services</Link></li>
                    </ul>
                    </details>
                </li>
                <li><Link to="/services/blog">Blog</Link></li>
                <li><Link to="/services/about">About</Link></li>
                </ul>
                </div>
                <a href="/" className="btn btn-ghost text-xl flex items-center gap-2">
                    <Logo className="w-8 h-8" />
                    Digiscape
                </a>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal px-1">
                <li><Link to="/services/products">Products</Link></li>
                <li>
                    <details>
                    <summary>Services</summary>
                    <ul className="p-2">
                        <li><Link to="/services/website-branding">Website & Branding</Link></li>
                        <li><Link to="/services/lead-generation">Online Marketing</Link></li>
                        <li><Link to="/services/it-services">IT Services</Link></li>
                    </ul>
                    </details>
                </li>
                <li><Link to="/services/blog">Blog</Link></li>
                <li><Link to="/services/about">About</Link></li>
                </ul>
            </div>
            <div className="navbar-end">
                <a className="btn" href="#cta">Contact Us</a>
            </div>
        </div>
    ); 
};

export default NavAndHero;
